import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, Thumbs } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/thumbs';
import './media-gallery.scss';

class MediaGallery {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-media-gallery',
            sliderAttr: 'main',
            sliderThumbnailAttr: 'thumbnail',
            sliderUi: 'slider-ui'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$mediaGallery = $element;
        this.$mediaGallerySlider = this.$mediaGallery.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$mediaGalleryThumbnailSlider = this.$mediaGallery.querySelector(`[${this.settings.initAttr}="${this.settings.sliderThumbnailAttr}"]`);
        this.mediaGallerySlider = null;
        this.mediaGalleryThumbnailSlider = null;
        this.$mediaGalleryUi = this.$mediaGallery.querySelector(`[${this.settings.initAttr}="${this.settings.sliderUi}"]`);
    }

    initialize () {
        this.initSliders();
    }

    initSliders () {
        const prevBTN = this.$mediaGallery.querySelector('.swiper-button-prev');
        const nextBTN = this.$mediaGallery.querySelector('.swiper-button-next');
        const scrollBar = this.$mediaGallery.querySelector('.swiper-scrollbar');
        const $wrapper = this.$mediaGalleryThumbnailSlider.querySelector('.swiper-wrapper');

        this.mediaGalleryThumbnailSlider = new Swiper(this.$mediaGalleryThumbnailSlider, {
            speed: 400,
            spaceBetween: 30,
            effect: 'fade',
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            on: {
                init: () => {
                    const $$allSlides = $wrapper.querySelectorAll('.swiper-slide');
                    const $$visibleSlides = $wrapper.querySelectorAll('.swiper-slide-fully-visible');

                    if ($$visibleSlides.length === $$allSlides.length) {
                        this.$mediaGalleryThumbnailSlider.classList.remove('media-gallery__slider--frame');
                    } else {
                        this.$mediaGalleryThumbnailSlider.classList.add('media-gallery__slider--frame');
                    }
                }
            }

        });

        this.mediaGallerySlider = new Swiper(this.$mediaGallerySlider, {
            modules: [Navigation, Scrollbar, A11y, Thumbs],
            speed: 400,
            spaceBetween: 30,
            slidesPerView: 1,
            scrollbar: {
                el: scrollBar,
                draggable: true,
                dragSize: 50
            },
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide'
            },
            navigation: {
                prevEl: prevBTN,
                nextEl: nextBTN,
                addIcons: false,
            },
            thumbs: {
                swiper: this.mediaGalleryThumbnailSlider
            }
        });

        this.mediaGalleryThumbnailSlider.on('resize', () => {
            if ($wrapper) {
                const $$allSlides = $wrapper.querySelectorAll('.swiper-slide');
                const $$visibleSlides = $wrapper.querySelectorAll('.swiper-slide-fully-visible');

                if ($$visibleSlides.length === $$allSlides.length) {
                    $wrapper.classList.add('media-gallery__slider-wrapper--align-right');
                    this.$mediaGalleryThumbnailSlider.classList.remove('media-gallery__slider--frame');
                    this.$mediaGalleryUi.classList.add('media-gallery__slider-ui--hide');
                } else {
                    $wrapper.classList.remove('media-gallery__slider-wrapper--align-right');
                    this.$mediaGalleryThumbnailSlider.classList.add('media-gallery__slider--frame');
                    this.$mediaGalleryUi.classList.remove('media-gallery__slider-ui--hide');
                }
            }
        });

        this.mediaGallerySlider.on('slideChange', (e) => {
            this.mediaGalleryThumbnailSlider.slideTo(this.mediaGallerySlider.activeIndex);
        });

        this.mediaGalleryThumbnailSlider.on('progress', (e) => {
            const $$allSlides = $wrapper.querySelectorAll('.swiper-slide');
            const $$visibleSlides = $wrapper.querySelectorAll('.swiper-slide-fully-visible');

            if (e.progress === 1) {
                this.$mediaGalleryThumbnailSlider.classList.remove('media-gallery__slider--frame');
            } else {
                if ($$visibleSlides.length !== $$allSlides.length) {
                    this.$mediaGalleryThumbnailSlider.classList.add('media-gallery__slider--frame');
                }
            }
        });
    }
}

export { MediaGallery };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$MediaGallery = $context.querySelectorAll('[data-media-gallery="root"]');

        for (let i = 0; i < $$MediaGallery.length; i++) {
            const $MediaGallery = $$MediaGallery[i];
            const MediaGalleryAPI = new MediaGallery($MediaGallery);
            MediaGalleryAPI.initialize();
        }
    }
});
